import { createTheme } from '@mui/material';
import { typography } from './typography';
import { palette } from './palette';

export const customTheme = createTheme({
	typography,
	palette,
});